
<div class="job-widget" :type="type" @click="handleClick">
	<div class="job-header">
		<!-- @slot Used to display job widget header <br/> Note : use html element with 'title' class to display header -->
		<slot name="header" />
	</div>
	<div class="job-body">
		<!-- @slot Used to display widget content<br/> e.g. LabelValue component is used display key value data -->
		<slot />
	</div>
	<div class="job-footer">
		<!-- @slot Used to display widget footer <br/> e.g. ProgressBar is used display progress of stages-->
		<slot name="footer" />
	</div>
</div>
